import { packsClient } from "lib/clients";
import { encrypt } from "lib/e2ee/helper";
import { Asset } from "lib/types";

export const updateAsset = async (asset: Asset<unknown>, sessionKey?: any): Promise<void> => {
  const updatedAsset: any = {}

  if (asset.data !== null) {
    if (asset.enc_data) {
      updatedAsset.enc_data = await encrypt(asset.data, sessionKey);
    }
    else {
      updatedAsset.data = asset.data;
    }
  }

  if (asset.order >= 0) {
    updatedAsset.order = asset.order;
  }

  await packsClient.updateAsset(asset.pack_id, asset.id, updatedAsset);
};

